import { Box, Chip, Paper, TableRow, Typography } from '@mui/material'
import { XlsxIcon } from 'assets/icons/xlsx-icon'
import AdvancedTableWrapper from 'components/AdvancedTable'
import { LabelBox } from 'components/label-box'
import { format } from 'date-fns'
import { Log } from 'pages/Logs/Logs.types'
import { useTranslation } from 'react-i18next'
import { renderCells } from 'utils/renderCells'

export const HistoryLogs = ({ marketCode, marketDescription }: { marketCode: string; marketDescription?: string }) => {
  const { t } = useTranslation()

  const description = marketDescription ? `-${marketDescription}` : ''

  return (
    <Box height="100%" display="flex" flexDirection="column">
      <Typography
        border="1px solid"
        borderColor="grey.200"
        sx={{ backgroundColor: 'grey.50', borderTopLeftRadius: 16, borderTopRightRadius: 16 }}
        px={2.5}
        pt={1}
        fontWeight={600}
        color="grey.900"
        pb={1}
        position="relative"
        mb="-12px"
      >
        History log
      </Typography>
      <Paper
        sx={{
          pt: 2.25,
          px: 2,
          gap: 2,
          pb: 2.25,
          flex: 1,
          zIndeX: 2,
        }}
      >
        <Box width="100%">
          <AdvancedTableWrapper<Log>
            endpoint={`logs?order=DESC&name=import prize draw winners&description=market code: ${marketCode}${description};`}
            headings={[
              { type: 'empty', name: t('common.name'), field: 'name' },
              { type: 'empty', name: t('common.createdAt'), field: 'createdAt', width: 160 },
              { type: 'empty', name: t('common.status'), field: 'user', width: 120 },
              { type: 'empty', name: t('common.author'), field: 'user', width: 180 },
            ]}
            disableSearchParams
            name="logs"
            disableFilters
            options={{}}
            renderRow={row => (
              <TableRow>
                {renderCells([
                  {
                    label: t('common.name'),
                    breakWord: true,
                    value: (
                      <Box display="flex" gap={1.5}>
                        <XlsxIcon />
                        <Box>
                          <LabelBox first={row.name} second={row.description} />
                        </Box>
                      </Box>
                    ),
                  },
                  {
                    label: t('common.createdAt'),
                    value: <LabelBox second={format(new Date(row.createdAt), 'MMM dd, yyyy')} />,
                  },
                  {
                    label: t('common.status'),
                    value: (
                      <Chip
                        variant="outlined"
                        label={row.name.includes('approved') ? 'Approved and sent' : 'Ready for approval'}
                        color={row.name.includes('approved') ? 'success' : 'info'}
                      />
                    ),
                  },
                  {
                    label: t('common.customer'),
                    value: <LabelBox first={row.user?.name} second={row.user?.email} />,
                  },
                ])}
              </TableRow>
            )}
          />
        </Box>
      </Paper>
    </Box>
  )
}
